import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Page from '../../../components/layout/Page';
import ClubCalendar from './ClubCalendar';
import { YButton } from '../../../ui/YButton';
import api from '../../../utils/api';
import { fetchClub } from '../utils/clubsCache';

export default function ClubCalendarPage({
  embedded = false,
  clubId: clubIdProp,
  isPresident: isPresidentProp,
  club: clubProp,
}) {
  const { clubId: clubIdParam } = useParams();
  const clubId = clubIdProp ?? clubIdParam;
  const navigate = useNavigate();
  const [club, setClub] = useState(null);

  const loadClub = useCallback(async () => {
    if (!clubId) return;
    try {
      const resp = await fetchClub(api, clubId);
      setClub(resp.data);
    } catch {
      /* club title optional */
    }
  }, [clubId]);

  useEffect(() => {
    if (!embedded) loadClub();
  }, [embedded, loadClub]);

  const isPresident = isPresidentProp ?? !!club?.is_president;

  const calendar = <ClubCalendar clubId={clubId} isPresident={isPresident} club={clubProp || club} />;

  if (embedded) {
    return (
      <div className="club-calendar-page club-calendar-page--embedded" data-testid="club-calendar-page">
        {calendar}
      </div>
    );
  }

  return (
    <Page>
      <Container className="mt-1 club-calendar-page" data-testid="club-calendar-page">
        <div className="d-flex align-items-center gap-2 mb-3">
          <YButton variant="secondary" onClick={() => navigate(`/clubs/${clubId}`)}>
            Back to Club
          </YButton>
          <h3 className="mb-0 ms-2">{club?.name || 'Club'} Calendar</h3>
        </div>
        {calendar}
      </Container>
    </Page>
  );
}

ClubCalendarPage.propTypes = {
  embedded: PropTypes.bool,
  clubId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isPresident: PropTypes.bool,
  club: PropTypes.object,
};
